export var GraphEnum;

(function (GraphEnum) {
  GraphEnum["DEFAULT_EDGE_NAME"] = "\0";
  GraphEnum["GRAPH_NODE"] = "\0";
  GraphEnum["EDGE_KEY_DELIM"] = "\x01";
})(GraphEnum || (GraphEnum = {}));